/**
 * Capitalizes the first letter of a word.
 * @param word - The word to capitalize.
 * @returns The capitalized word.
 */
export function capitalize(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
